// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 666) return "wp-content/themes/encore-theme/public/scripts/app/666.js";
	// return url for filenames based on template
	return undefined;
};